import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import Grid from '../../../components/molecules/Grid';
import { getFilterdInfoData, clearFilterData } from '../Filters/redux/actions';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { filteredData, selectedFiltersData } from '../Filters/redux/selectors';
import { searchTermData } from './redux/selectors';
import FilteredList from '../FilteredList';
import {
  LISTINGLAYOUT_COMPONENT,
  FILTER_SECTION,
  FILTEREEDLIST_SECTION,
} from './locators';
import useStyles from './style';
import { getComponentName } from '../../../utils/getPageComponentInfo';
import { getLocalStorage } from './../../../../utils/localStorage';

const payloadCall = (language) => {
  let favData = JSON.parse(getLocalStorage('favorites') || '[]');

  let solrPayloadToFetchFilter = {};
  solrPayloadToFetchFilter.itemIDs = favData;
  solrPayloadToFetchFilter.language = language;
  solrPayloadToFetchFilter.facetFields = [];
  solrPayloadToFetchFilter.limit = 9;
  solrPayloadToFetchFilter.offset = 0;
  solrPayloadToFetchFilter.filters = [];
  solrPayloadToFetchFilter.sortingOrder = {
    order: 'asc',
    sortBy: 'name',
  };

  return solrPayloadToFetchFilter;
};

const FavoriteSubLayout = props => {
  const { filteredData, searchTermData, sitecoreContext, appConfig = {} } = props;
  const classes = useStyles();
  const [isFilterFirstLoad, setIsFilterFirstLoad] = React.useState(false);

  const [isFirstLoad, setIsFirstLoad] = React.useState(true);

  const [isFirstListingFetchLoad, setFirstListingFetchLoad] = React.useState(false);

  const localFavorites = JSON.parse(getLocalStorage('favorites') || '[]');
  const [localFavoritesCount, setlocalFavoritesCount] = React.useState(0);
  const isLoading = get(filteredData, 'loading', '');

  const language = get(sitecoreContext, 'language', '');

  const fetchListing = () => {
    const payload = payloadCall(language);
    props.getFilterdInfoData({
      apiUrl: `${appConfig.SOLR_FAVORITE_SEARCH_API}`,
      payload: payload,
    });
    setFirstListingFetchLoad(true);
  };

  // Fetching Filtered Results
  useEffect(() => {
    // For first load
    if (isFilterFirstLoad && !isFirstListingFetchLoad) {
      fetchListing();
    }

    setIsFilterFirstLoad(true);
  }, [JSON.stringify(filteredData.data)]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  useEffect(() => {
    setlocalFavoritesCount(filteredData.totalFavorites)
  }, [localFavorites]);

  return (
    <Grid item className={classes.favGridWrapper}>
      {localFavoritesCount === 0 && !isLoading && !isFirstLoad && (<Placeholder name="no-favorite-result" rendering={props.rendering} appConfig={props.appConfig} />)}

      {(localFavoritesCount > 0) && (
        <Grid
          item
          className={classes.listingLayoutWrappeer}
          data-locator={LISTINGLAYOUT_COMPONENT}
        >
          <Grid
            item
            className={classes.filterSection}
            data-locator={FILTER_SECTION}
          >
            <Placeholder name="vad-left-col" rendering={props.rendering} appConfig={props.appConfig} parentComponentName="FavoriteSubLayout" />
          </Grid>
          <Grid
            item
            className={classes.filterdList}
            data-locator={FILTEREEDLIST_SECTION}
            aria-live="polite"
          >
            <FilteredList searchTerm={searchTermData.data} componentName={getComponentName(props)} appConfig={props.appConfig} />
          </Grid>
        </Grid>)}
    </Grid>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
    clearFilterData: params => dispatch(clearFilterData(params)),
  };
};

export const mapStateToProps = createStructuredSelector({
  filteredData: filteredData,
  searchTermData: searchTermData,
  selectedFiltersData: selectedFiltersData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(
      connect(mapStateToProps, mapDispatchToProps)(FavoriteSubLayout)
    )
  )
);
